import { FaRegKeyboard, FaUsers } from "react-icons/fa";
import { RiQuillPenLine } from "react-icons/ri";
import { LuBadgeDollarSign } from "react-icons/lu";
import { TfiStatsUp } from "react-icons/tfi";
import { BsCreditCardFill } from "react-icons/bs";
import StatisticsChart from "./StatisticsChart";
import axios from "./../../utils/axiosInstance";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import {
  AnthropicOverview,
  ApifyOverview,
  AWSOverview,
  DeepseekOverview,
  OpenAIOverview,
} from "./ViewInDetailed";

const Dashboard = () => {
  const [data, setData] = useState(null); // Initialize state
  const [dropDownNo, setDropDownNo] = useState(0);
  const [apifyUsage, setApifyUsage] = useState(null);

  useEffect(() => {
    const importData = async () => {
      try {
        const todayResponse = await axios.get(
          `${process.env.REACT_APP_BASED_URL}/stats/today`
        );
        const monthlyResponse = await axios.get(
          `${process.env.REACT_APP_BASED_URL}/stats/month`
        );
        const totalResponse = await axios.get(
          `${process.env.REACT_APP_BASED_URL}/stats/overall`
        );
        setData([todayResponse.data, monthlyResponse.data, totalResponse.data]); // Update state

        // const apifyResponse = await axios.get(
        //   `${process.env.REACT_APP_BASED_URL}/usageCheck/apify`
        // );
        // setApifyUsage(apifyResponse.data);

        function getCurrentMonthDates() {
          const date = new Date();
          const year = date.getFullYear();
          const month = date.getMonth() + 1; // Months are 0-based

          const startDate = `${year}-${String(month).padStart(2, "0")}-01`;
          const lastDay = new Date(year, month, 0).getDate();
          const endDate = `${year}-${String(month).padStart(
            2,
            "0"
          )}-${lastDay}`;

          return { startDate, endDate };
        }

        const { startDate, endDate } = getCurrentMonthDates();
        // const params = {
        //   start_date: startDate,
        //   end_date: endDate,
        // };
        // const url = "https://api.openai.com/v1/usage";
        // const headers = {
        //   Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
        // };

        // const openaiResponse = await axios.get(url, { headers, params });
        // console.log(openaiResponse.data);
      } catch (error) {
        console.log(error);
        toast.error("Failed to import data");
      }
    };

    importData();
  }, []); // Empty dependency array ensures this runs once on mount

  // Conditionally render content based on whether data is available
  if (!data) {
    return <p>Loading...</p>; // Show a loading state while data is being fetched
  }

  const limitPercentage = 80;

  return (
    <div className=" bg-sky-50 px-2 py-5">
      <div className="grid grid-cols-[1fr_1fr_1fr] gap-4 items-center justify-between p-5">
        <div className="flex flex-col h-auto p-5 gap-2 bg-white rounded-2xl border border-neutral-300">
          <button className="flex items-end justify-start gap-5">
            <div className="text-lime-500">
              <FaUsers size={"30px"} />
            </div>
            <p className="text-lime-500 text-3xl font-medium">Customers</p>
          </button>
          <div className="flex justify-between text-2xl text-neutral-600 font-medium">
            <p>Today</p>
            <p>{data[0].newCustomersCount}</p>
          </div>
          <div className="flex justify-between text-2xl text-neutral-600 font-medium">
            <p>This Month</p>
            <p>{data[1].newCustomersCount}</p>
          </div>
          <div className="flex justify-between text-2xl text-neutral-600 font-medium">
            <p>Total</p>
            <p>{data[2].newCustomersCount}</p>
          </div>
        </div>
        <div className="flex flex-col h-auto p-5 gap-2 bg-white rounded-2xl border border-neutral-300">
          <div className="flex items-end justify-start gap-5">
            <div className="text-lime-500">
              <RiQuillPenLine size={"30px"} />
            </div>
            <p className="text-lime-500 text-3xl font-medium">CreditUsed</p>
          </div>
          <div className="flex justify-between text-2xl text-neutral-600 font-medium">
            <p>Today</p>
            <p>{Math.floor(data[0].totalCreditsUsed)}</p>
          </div>
          <div className="flex justify-between text-2xl text-neutral-600 font-medium">
            <p>This Month</p>
            <p>{Math.floor(data[1].totalCreditsUsed)}</p>
          </div>
          <div className="flex justify-between text-2xl text-neutral-600 font-medium">
            <p>Total</p>
            <p>{Math.floor(data[2].totalCreditsUsed)}</p>
          </div>
        </div>
        <div className="flex flex-col h-auto p-5 gap-2 bg-white rounded-2xl border border-neutral-300">
          <div className="flex items-end justify-start gap-5">
            <div className="text-lime-500">
              <LuBadgeDollarSign size={"30px"} />
            </div>
            <p className="text-lime-500 text-3xl font-medium">Revenue</p>
          </div>
          <div className="flex justify-between text-2xl text-neutral-600 font-medium">
            <p>Today</p>
            <p>{data[0].totalMoneyEarned}</p>
          </div>
          <div className="flex justify-between text-2xl text-neutral-600 font-medium">
            <p>This Month</p>
            <p>{data[1].totalMoneyEarned}</p>
          </div>
          <div className="flex justify-between text-2xl text-neutral-600 font-medium">
            <p>Total</p>
            <p>{data[2].totalMoneyEarned}</p>
          </div>
        </div>
      </div>

      {/*Third-party usage*/}
      {/* <div className="flex flex-col w-auto h-auto p-5 m-5 gap-5 bg-white rounded-2xl border border-neutral-300">
        <div className="flex items-start justify-start">
          <div className="flex items-end justify-start gap-5">
            <div className="text-rose-500">
              <BsCreditCardFill size={"30px"} />
            </div>
            <p className="text-rose-500 text-3xl font-medium">
              Third-party usage
            </p>
          </div>
        </div>
        <div className="flex items-start justify-center">
          <div className="flex flex-col justify-between w-[18vw] text-neutral-600 font-medium px-10 border-r-2 border-neutral-500">
            <button
              className="text-2xl mb-3 text-right text-fuchsia-500 hover:text-fuchsia-700"
              onClick={() => {
                setDropDownNo(1);
              }}
            >
              OpenAI
            </button>
            <div className="flex items-end justify-between">
              <p className="text-xs">Usage</p>
              <p className="text-xs">15$ / 30$</p>
            </div>
            <div
              style={{
                position: "relative",
                width: "100%",
              }}
            >
              <ProgressBar
                completed={50}
                bgColor="fuchsia"
                height="2vh"
                isLabelVisible={false}
              />
              <div
                style={{
                  position: "absolute",
                  left: `${limitPercentage}%`,
                  top: 0,
                  bottom: 0,
                  width: "2px",
                  backgroundColor: "red", // Color for the limit line
                }}
              ></div>
            </div>
            <div className="flex justify-between text-lg text-neutral-600 font-medium mt-3">
              <p>Total</p>
              <p>240$</p>
            </div>
            {dropDownNo === 1 && <OpenAIOverview func={{ setDropDownNo }} />}
          </div>
          <div className="flex flex-col justify-between w-[18vw] text-neutral-600 font-medium px-10 border-r-2 border-neutral-500">
            <button
              className="text-2xl mb-3 text-right text-orange-500 hover:text-orange-700"
              onClick={() => {
                setDropDownNo(2);
              }}
            >
              Anthropic
            </button>
            <div className="flex items-end justify-between">
              <p className="text-xs">Usage</p>
              <p className="text-xs">15$ / 30$</p>
            </div>
            <div
              style={{
                position: "relative",
                width: "100%",
              }}
            >
              <ProgressBar
                completed={50}
                bgColor="orange"
                height="2vh"
                isLabelVisible={false}
              />
              <div
                style={{
                  position: "absolute",
                  left: `${limitPercentage}%`,
                  top: 0,
                  bottom: 0,
                  width: "2px",
                  backgroundColor: "red", // Color for the limit line
                }}
              ></div>
            </div>{" "}
            <div className="flex justify-between text-lg text-neutral-600 font-medium mt-3">
              <p>Total</p>
              <p>240$</p>
            </div>
            {dropDownNo === 2 && <AnthropicOverview func={{ setDropDownNo }} />}
          </div>
          <div className="flex flex-col justify-between w-[18vw] text-neutral-600 font-medium px-10 border-r-2 border-neutral-500">
            <button
              className="text-2xl mb-3 text-right text-blue-500 hover:text-blue-700"
              onClick={() => {
                setDropDownNo(3);
              }}
            >
              Deepseek
            </button>
            <div className="flex items-end justify-between">
              <p className="text-xs">Usage</p>
              <p className="text-xs">15$ / 30$</p>
            </div>
            <div
              style={{
                position: "relative",
                width: "100%",
              }}
            >
              <ProgressBar
                completed={50}
                bgColor="blue"
                height="2vh"
                isLabelVisible={false}
              />
              <div
                style={{
                  position: "absolute",
                  left: `${limitPercentage}%`,
                  top: 0,
                  bottom: 0,
                  width: "2px",
                  backgroundColor: "red", // Color for the limit line
                }}
              ></div>
            </div>{" "}
            <div className="flex justify-between text-lg text-neutral-600 font-medium mt-3">
              <p>Total</p>
              <p>240$</p>
            </div>
            {dropDownNo === 3 && <DeepseekOverview func={{ setDropDownNo }} />}
          </div>
          <div className="flex flex-col justify-between w-[18vw] text-neutral-600 font-medium px-10 border-r-2 border-neutral-500">
            <button
              className="text-2xl mb-3 text-right text-lime-500 hover:text-lime-600"
              onClick={() => {
                setDropDownNo(4);
              }}
            >
              Apify
            </button>
            <div className="flex items-end justify-between">
              <p className="text-xs">Usage</p>
              <div className="flex gap-1">
                <p className="text-xs">{apifyUsage.usedUsage}$</p>
                <p className="text-xs">/</p>
                <p className="text-xs">{apifyUsage.maxUsage}$</p>
              </div>
            </div>
            <div
              style={{
                position: "relative",
                width: "100%",
              }}
            >
              <ProgressBar
                completed={(apifyUsage.usedUsage / apifyUsage.maxUsage) * 100}
                bgColor="lime"
                height="2vh"
                isLabelVisible={false}
              />
              <div
                style={{
                  position: "absolute",
                  left: `${limitPercentage}%`,
                  top: 0,
                  bottom: 0,
                  width: "2px",
                  backgroundColor: "red", // Color for the limit line
                }}
              ></div>
            </div>
            <div className="flex justify-between text-lg text-neutral-600 font-medium mt-3">
              <p>Total</p>
              <p>{localStorage.getItem("ApifyTotalCharged")}$</p>
            </div>
            {dropDownNo === 4 && <ApifyOverview func={{ setDropDownNo }} />}
          </div>
          <div className="flex flex-col justify-between w-[18vw] text-neutral-600 font-medium px-10">
            <button
              className="text-2xl mb-3 text-right text-slate-500 hover:text-slate-700"
              onClick={() => {
                setDropDownNo(5);
              }}
            >
              AWS
            </button>
            <div className="flex items-end justify-between">
              <p className="text-xs">Usage</p>
              <div>
                <p className="text-xs">15$ / 30$</p>
              </div>
            </div>
            <div
              style={{
                position: "relative",
                width: "100%",
              }}
            >
              <ProgressBar
                completed={50}
                bgColor="gray"
                height="2vh"
                isLabelVisible={false}
              />
              <div
                style={{
                  position: "absolute",
                  left: `${limitPercentage}%`,
                  top: 0,
                  bottom: 0,
                  width: "2px",
                  backgroundColor: "red", // Color for the limit line
                }}
              ></div>
            </div>
            <div className="flex justify-between text-lg text-neutral-600 font-medium mt-3">
              <p>Total</p>
              <p>240$</p>
            </div>
            {dropDownNo === 5 && <AWSOverview func={{ setDropDownNo }} />}
          </div>
        </div>
      </div> */}
      <div className="flex flex-col m-5 p-5 bg-white rounded-2xl border border-neutral-300 ">
        <div className="flex items-end justify-start gap-5 pb-5">
          <div className="text-indigo-500">
            <TfiStatsUp size={"30px"} />
          </div>
          <p className="text-indigo-500 text-3xl font-medium">Statistics</p>
        </div>
        <StatisticsChart />
      </div>
    </div>
  );
};

export default Dashboard;
